
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRef } from 'react';
import styled from 'styled-components';

import SectionText from '../../components/molecules/SectionText';
import Title from '../../components/molecules/Title.jsx';
import IntroSection from '../../components/wrappers/IntroSection';
import PageWrapper from '../../components/wrappers/PageWrapper';
import Section from '../../components/wrappers/Section';
import nextI18NextConfig from '../../next-i18next.config.js';

import { renderScript } from '@/utilities/functions';

// #region STYLE
const UnderLineTitle = styled.span`
  text-decoration: ${props => props.isSecondary ? 'none' : 'underline'};
  padding: ${props => props.isSecondary ? '.3em 0 .3em .7em' : '.6em 0'};
  font-weight: ${props => props.isSecondary ? 'bold' : 'normal'};
`;

const CustomSection = styled(Section)`
  height: auto;
  p {
    font-size: 1em;
  }
  p > span {
    display: block;
    padding: .4em 1em .2em;
  }
`;
// #endregion

// #region COMPONENT
const Cgu = ({ currentPath, currentLang }) => {
	const scrollTo = useRef(null);

	// #region RENDER
	return (
		<PageWrapper
			title="Conditions générales d'utilisation"
			description="Retrouvez les conditions générales d'utilisation ainsi que les mentions légales de l'entreprise de travail temporaire Bruce."
			alternateUrl={{fr:'', en:'', es:''}}
			currentPath={currentPath}
			currentLang={currentLang}
		>
			<Head>
				{renderScript({
					'@context': 'https://schema.org',
					'@type': 'BreadcrumbList',
					'itemListElement': [{
						'@type': 'ListItem',
						'position': 1,
						'name': 'Accueil',
						'item': 'https://www.bruce.work/',
					},{
						'@type': 'ListItem',
						'position': 2,
						'name': 'CGU',
						'item': 'https://www.bruce.work/cgu',
					}],
				})}
			</Head>
			<IntroSection underlineColor="blue" extraSpace isJobOffer scrollTo={scrollTo}>
				<h1>CONDITIONS GÉNÉRALES D&apos;UTILISATION DU SITE BRUCE</h1>
			</IntroSection>
			<CustomSection  scrollTo={scrollTo}>
				<SectionText>
					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">
						1. MENTIONS LÉGALES
					</Title>
					<p>
						<UnderLineTitle>Editeur du site :</UnderLineTitle>
						<span>Le service accessible depuis le site internet et l’application Bruce (le « Service ») est proposé par la société Bruce, société
							par actions simplifiée sise 14 rue Soleillet à Paris (75020) au capital social de 57 750 euros, immatriculée au registre du commerce
							et
							des sociétés de Paris sous le numéro 818 435 240, ayant comme numéro de TVA intracommunautaire FR22 818 435 240.</span>
						<span>Le Directeur de la publication est Adrien Moreira.</span>
						<span>Numéro de téléphone : 09 53 79 37 01</span>
						<span>Adresse de courrier électronique : hey@bruce.work</span>
					</p>
					<p>
						<UnderLineTitle>
							Hébergeur du site :
						</UnderLineTitle>
						<span>Le site <a href='https://www.bruce.work'>www.bruce.work</a> est hébergé par Amazon Web Services, Inc., dont le siège social est
							situé P.O. Box 81226 Seattle, WA 98108-1226 (http://aws.amazon.com).</span>
						<span>L’ensemble des données de la société Bruce SAS est hébergé par la société Amazon Web Services, Inc., dans des serveurs localisés
							au sein de l’Union Européenne.</span>
						<span>Bruce peut être contactée aux coordonnées suivantes :</span>
						<span>Adresse postale : Bruce - 14 rue Soleillet – 75020 Paris</span>
						<span>Adresse électronique : hey@bruce.work</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						2. OBJET

					</Title>
					<p>
						<span>Les présentes conditions générales d’utilisation (« CGU ») ont pour objet de définir les conditions dans lesquelles Bruce met à
							disposition des Utilisateurs les outils et l’assistance (le “Service”) permettant, principalement à distance :</span>
						<span>(i) aux entreprises utilisatrices (« Entreprises ») d’identifier la(es) personne(s) à la recherche d’un emploi (« Candidat(s) »)
							dont le(s) profil(s) correspond(ent) le mieux à leurs besoins pour réaliser des missions de travail, temporaires ou  non, dans leur
							structure(« Missions »), et, le cas échéant, de les embaucher, par des contrats à durée déterminée (“CDD”) ou indéterminée (“CDI”),
							des
							contrats de stage ou des contrats en alternance;</span>
						<span>(ii) aux Candidats de renseigner leur profil afin de pouvoir être contactés pour réaliser des Missions, et, le cas échéant, être
							recruté par des CDD, CDI, contrats de stage ou contrats en alternance,</span>
						<span>(iii) de procéder aux opérations préalables nécessaires à la réalisation de la Mission par le(s) Candidat(s) retenu(s) au bénéfice
							d’une Entreprise (« Intérimaire(s) »),</span>
						<span>(iv) aux Candidats signataires d’un CDD, CDI, contrat de stage ou contrat en alternance (“Intérimaires”), de procéder aux
							formalités se rapportant au bon déroulement de leur Mission.</span>
						<span>Les présentes CGU s’appliquent à l’utilisation du Service par les Entreprises et par les Candidats et Intérimaires préalablement
							inscrits et ayant accepté préalablement et sans réserve les CGU par un clic matérialisant leur accord (ensemble les « Utilisateurs
							»).
							Elles forment, avec chaque Contrat de Mise à Disposition ou de Mission conclu, le Contrat. En cas de contradiction entre les
							présentes
							CGU et un Contrat de Mise à Disposition ou de Mission, les stipulations</span> <span>du Contrat de Mise à Disposition ou de Mission
								prévaudront.</span>
						<span>Bruce se réserve le droit de modifier tout ou partie et à tout moment les CGU. Il appartient en conséquence à l’Utilisateur de se
							référer régulièrement à la dernière version des CGU disponible en permanence sur le site.</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						3. ACCÈS AUX SERVICES

					</Title>
					<p>
						<span>L’accès aux Services est subordonné à l’inscription préalable de l’Utilisateur. Lors de son inscription puis au cours de
							l’utilisation qu’il fait du Service, l’Utilisateur s’engage à communiquer des données exactes concernant son identité ou ses
							expériences
							et à informer Bruce sans délai de tout changement les affectant, en utilisant les outils du Service. A cet égard, l’Utilisateur est
							informé que Bruce se réserve le droit d’effectuer toute vérification nécessaire afin de confirmer la sincérité des informations
							communiquées par l’Utilisateur (par exemple en contactant les anciens employeurs des Candidats).</span>
						<span>Les Services sont accessibles, sous réserve des restrictions prévues sur le Site :</span>
						<span>
							<ul>
								<li>
									à toute personne physique disposant de la pleine capacité juridique pour s’engager au titre des présentes Conditions
									Générales. La personne physique qui ne dispose pas de la pleine capacité juridique ne peut accéder à la Plateforme et aux
									Services qu’avec l’accord de son représentant légal ;
								</li>
								<li>
									à toute personne morale agissant par l’intermédiaire d’une personne physique disposant de la capacité juridique pour
									contracter au nom et pour le compte de ladite personne morale ;
								</li>
							</ul>
						</span>
						<span>L’Utilisateur s’engage à ne pas utiliser d’adresse électronique qui pourrait porter atteinte aux droits de tiers (nom
							patronymique, marque…), ni d’usurper un nom, une dénomination sociale ou une marque déposée. Bruce se réserve le droit de suspendre
							l’accès au Service et/ou de désactiver des comptes d’Utilisateurs qui ne respecteraient pas ces Conditions Générales, sans préavis
							ni
							indemnité.</span>
						<span>Dans le cadre de l’utilisation du Service, l’Utilisateur s’engage par ailleurs à conserver ses identifiant et mot de passe secrets
							et à ne les divulguer à aucun tiers non autorisé, l’Utilisateur étant seul responsable de l’utilisation faite du Service en
							utilisant
							lesdits identifiant et mot de passe, sauf preuve
							d&apos;une utilisation frauduleuse non imputable à sa négligence. A ce titre, l’Utilisateur s’engage à avertir Bruce immédiatement
							de toute perte ou constat d&apos;utilisation frauduleuse de ses identifiant et/ou mot de passe.</span>
						<span>L’Utilisateur est informé qu’il peut, à tout moment, demander sa désinscription du Site Internet ou de l’application en qualité
							d’Utilisateur, en adressant un message dans le chat de l’application ou par mail à administration@bruce.work.
							Bruce s’engage à supprimer le compte/profil de l’Utilisateur dans les meilleurs délais.</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						4. DESCRIPTION DES SERVICES

					</Title>
					<p>
						<span>Bruce propose aux Utilisateurs des Services relatifs à la recherche d’emploi et sélection des Candidats, indépendamment du type de
							contrat qui sera conclu. Les services de Bruce sont divisés en deux catégories :</span>
						<UnderLineTitle>
							4.1. Services destinés aux Entreprises
						</UnderLineTitle>
						<UnderLineTitle isSecondary>
							4.1.1. Recrutement en intérim
						</UnderLineTitle>
						<span>L’ensemble des Services susceptibles d’être proposés par Bruce aux Entreprises dans le cadre d’un recrutement en intérim sont
							listés ci-après :</span>
						<span>

							<ul>
								<li>accès 24h/24 et 7j/7 à l’interface utilisateur web “Bruce Entreprise” pour réaliser toutes les démarches nécessaires pour la
									commande et gestion des intérimaires.</li>
								<li>accès 24h/24 et 7j/7 à l’application mobile « Bruce Entreprise » pour réaliser toutes les démarches nécessaires pour la
									commande et gestion des intérimaires.</li>
								<li>Gestion unifiée sur les plateformes web et application Bruce des contrats de mise à disposition, signature électronique,
									stockage et suivi.</li>
								<li>Suivi des missions en cours et des Intérimaires en Mission au sein de
									l&apos;Entreprise via les plateformes web et application Bruce.</li>
								<li>Suivi de la facturation avec envoi par courriel et stockage pendant la durée légale des factures électroniques liées aux
									prestations fournies.</li>
								<li>Publication des nouveaux besoins via les plateformes en illimité sans aucune restriction, dans le respect des dispositions
									légales et réglementaires, notamment celles du Code du travail et plus particulièrement celles encadrant le recours à
									l’Intérim
									ou au Portage Salarial.</li>
								<li>Gestion des heures des Intérimaires en mission avec validation des relevés d’heures de façon automatique ou manuelle.</li>
								<li>Gestion des accès utilisateur au sein de l’Entreprise à la plateforme avec possibilité d’un nombre illimité de comptes
									utilisateurs.</li>
								<li>Accès à un espace personnel permettant de gérer les informations personnelles de l’utilisateur personne physique du compte
									Entreprise.</li>
								<li>Support via plateforme ou par téléphone, lors des horaires d’ouverture.</li>
								<li>Accès à des outils de qualification des candidats, tels que entretiens vidéo, CVs et tests.</li>
								<li>Possibilité de commander des Intérimaires en un clic sur la plateforme web sans besoin d&apos;interaction humaine.</li>
								<li>Possibilité de personnalisation des rapports de suivi des Missions.</li>
								<li>Accès aux algorithmes de qualification et sélection des Intérimaires et possibilité d’intervenir dans le processus de
									recrutement.</li>
								<li>Processus de recrutement adaptés au besoin individuel de chaque Entreprise avec mise en place d’un tableau de bord
									personnalisé.</li>
								<li>Système d&apos;évaluation des Missions et des Intérimaires et suivi des besoins des Entreprises.</li>
							</ul>
						</span>

						<span>L’accès à chacun des services proposés peut varier en fonction des besoins de l’Entreprise et des accords commerciaux signés avec
							Bruce.</span>
						<UnderLineTitle isSecondary>
							4.1.2. Placement en CDD et CDI
						</UnderLineTitle>
						<span>L’ensemble des Services susceptibles d’être proposés par Bruce aux Entreprises dans le cadre d’un recrutement en CDD ou CDI sont
							listés ci-après :</span>
						<span>
							<ul>
								<li>accès 24h/24 et 7j/7 à l’interface utilisateur web “Bruce Entreprise” pour réaliser toutes les démarches nécessaires pour la
									commande et gestion des recrutements.</li>
								<li>accès 24h/24 et 7j/7 à l’application mobile « Bruce Entreprise » pour réaliser toutes les démarches nécessaires pour la
									commande et gestion des recrutements.</li>
								<li>Suivi de la facturation avec envoi et stockage pendant la durée légale des factures électroniques liées aux prestations
									fournies.</li>
								<li>Publication des nouveaux besoins via les plateformes en illimité sans aucune restriction, dans le respect des dispositions
									légales et réglementaires, notamment celles du Code du travail;</li>
								<li>Gestion des accès utilisateur au sein de l’entreprise à la plateforme avec possibilité d’un nombre illimité de comptes
									utilisateurs.</li>
								<li>Accès à un espace personnel permettant de gérer les informations personnelles de l’utilisateur personne physique du compte
									Entreprise.</li>
								<li>Support via plateforme ou par téléphone, lors des horaires d’ouverture.</li>
								<li>Accès à des outils de qualification des candidats, tels que entretiens vidéo, CVs et tests.</li>
								<li>Accès à des outils de communication avec des candidats, tels que entretiens vidéo live, téléphone et chat.</li>
								<li>Possibilité de personnalisation des rapports de suivi des recrutements.</li>
								<li>Accès aux algorithmes de qualification et sélection des candidats et possibilité d’intervenir dans le processus de
									recrutement</li>
								<li>Processus de recrutement adaptés au besoin individuel de chaque Entreprise avec tableau de bord personnalisé.</li>
							</ul>
						</span>

						<span>L’accès à chacun des services proposés peut varier en fonction des besoins de l’Entreprise et des accords commerciaux signés avec
							Bruce.</span>
						<UnderLineTitle isSecondary>
							4.1.3. Plateforme Digitale de Recrutement
						</UnderLineTitle>
						<span>L’accès à la plateforme digitale de recrutement est fourni selon les modalités Gratuites et Premium. Chacune de ses modalités peut
							offrir des fonctionnalités différentes selon l’offre commerciale en vigueur. Toutes les changements sur l’offre en vigueur seront
							communiqués aux Utilisateurs du service, dans les meilleurs délais avant sa mise en place.</span>
						<span>L’ensemble des Services susceptibles d’être proposés par Bruce aux Entreprises dans le cadre d’un recrutement en intérim sont
							listés ci-après :</span>
						<span>
							<ul>
								<li>accès 24h/24 et 7j/7 à l’interface utilisateur web  “Bruce Entreprise” pour réaliser toutes les démarches nécessaires pour
									la commande et gestion des recrutements.</li>
								<li>accès 24h/24 et 7j/7 à l’application mobile « Bruce Entreprise » pour réaliser toutes les démarches nécessaires pour la
									commande et gestion des recrutements.</li>
								<li>Suivi de la facturation avec envoi et stockage pendant la durée légale des facture électroniques liées aux prestations
									fournies.</li>
								<li>Publication des nouveaux besoins via les plateformes en illimité sans aucune restriction, en respectant les dispositions
									légales et réglementaires, notamment celles du Code du travail et plus particulièrement celles encadrant le recours à
									l’Intérim
									ou au Portage Salarial.</li>
								<li>Gestion des accès utilisateur au sein de l’entreprise à la plateforme avec possibilité d’un nombre illimité de comptes
									utilisateurs.</li>
								<li>Accès à un espace personnel permettant permets de gérer les informations personnelles de l’utilisateur personne physique et
									du compte de l’Entreprise.</li>
								<li>Support via plateforme ou par téléphone, lors des horaires d’ouverture.</li>
								<li>Accès à des outils de qualification des candidats, tels que entretiens vidéo, CVs et tests.</li>
								<li>Accès à des outils de communication avec des candidats, tels que entretiens vidéo live, téléphone et chat.</li>
								<li>Accès aux algorithmes de qualification et sélection des candidats et possibilité d’intervenir sur le recrutement</li>
								<li>Processus de recrutement adaptés au besoin individuel de chaque Entreprise avec tableau de bord personnalisé.</li>
							</ul>
						</span>

						<span>L’accès à chacun des services proposés peut varier en fonction des besoins de l’Entreprise et des accords commerciaux signés avec
							Bruce. L’accès aux services peut également varier selon la modalité d’accès Gratuite ou Premium.</span>
						<UnderLineTitle>
							4.2. Services destinés aux Candidats
						</UnderLineTitle>
						<UnderLineTitle isSecondary>
							4.2.1. Plateforme Digitale de Recrutement
						</UnderLineTitle>
						<span>L’ensemble des Services proposés par Bruce aux Candidats sont listés ci-après :</span>
						<span>
							<ul>
								<li>Accès 24h/24 et 7j/7 à des outils de communication avec des consultants en recrutement Bruce, tels que entretiens vidéo live
									et chat. et téléphone.</li>
								<li>Accès 24h/24 et 7j/7 à l’application mobile « Bruce » pour réaliser toutes les démarches nécessaires à la recherche d’emploi
									sur les offres disponibles dans la plateforme.</li>
								<li>Gestion unifiée sur l’application Bruce des contrats de mise à disposition, signature électronique, stockage pendant la
									durée légale et suivi.</li>
								<li>Gestion unifié sur l’application Bruce des fiches de paie.</li>
								<li>Gestion des heures des Missions effectués avec validation des relevés d’heures de façon automatique ou manuelle.</li>
								<li>Accès à des outils de suivi des candidatures réalisés avec la plateforme Bruce.</li>
							</ul>
						</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						5. PROPRIÉTÉ INTELLECTUELLE

					</Title>
					<p>
						<span>Toutes les marques citées ou utilisées sur le Site, sont la propriété de leur titulaire respectif. Cela s’applique également pour
							les vidéos et photos proposées sur les pages offres, qui demeurent la propriété de leurs ayants droits respectifs. La reproduction
							l’imitation et/ou l’apposition de ces marques sans avoir obtenu l’autorisation préalable de leurs titulaires constitue un délit
							pénalement répréhensible.</span>
						<span>L’ensemble du Site relève de la législation française et à ce titre est protégé par les dispositions du Code de la propriété
							intellectuelle, notamment par celles de ses dispositions relatives à la propriété littéraire et artistique, aux droits d’auteur et à
							la
							protection des bases de données. Ces droits sont la propriété exclusive de Bruce, à l’exception des vidéos dont la propriété est
							celle
							de ses différents clients.</span>

						<span>Le Code de la propriété intellectuelle n’autorise aux termes de l’article L.122-5, d’une part, que les copies ou reproductions
							strictement réservées à l’usage privé du copiste et non destinées à une utilisation collective et, d’autre part, que les analyses et
							les
							courtes citations dans un but d’exemple et d’illustration.</span>

						<span>De même, l’article L.342-3 du Code de la propriété intellectuelle n’autorise que l’extraction ou la réutilisation d’une partie non
							substantielle du contenu d’une base de données mise à la disposition du public par son titulaire. Par conséquent, toute
							représentation
							ou reproduction non autorisée du Site, par quelque moyen que ce soit, est strictement interdite sous peine de poursuites
							judiciaires.</span>

						<span>Le contrevenant s’expose à des sanctions civiles et pénales et notamment aux peines prévues aux articles L.335-2 et L.343-1 du
							Code de la propriété intellectuelle.</span>
						<span>Toute utilisation quelle qu’elle soit des noms de marques et logos du Site incluant notamment, mais non limitativement, Bruce,
							ainsi que les noms commerciaux détenus par les partenaires de Bruce est interdite sans l’autorisation des titulaires des
							droits.</span>
						<span>Toutes les photographies du Site sont protégées par un copyright.</span>
						<span>Le copyright s’applique également aux logos, vidéos, photos mis à disposition par les clients et/ou partenaires de Bruce.</span>
						<span>Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques
							et photographiques.</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						6. DONNÉES PERSONNELLES

					</Title>
					<p>
						<span>Toutes les informations collectées dans le cadre de l’utilisation du Service et au cours de l’exécution des Contrats de travail,
							en ce compris les évaluations des Candidats et des Intérimaires, sont utilisées par Bruce pour la gestion du Service, notamment
							l’exécution desdits Contrats (y compris pour le respect des obligations légales et réglementaires afférentes à l’exécution d’un
							contrat
							de travail), et la gestion de la relation entre l’Utilisateur et Bruce, mais également afin de mieux connaître les attentes des
							utilisateurs du Service. Les informations sans lesquelles la fourniture du Service n’est pas possible sont signalées dans les
							formulaires. Le Candidat est informé que les informations le concernant, y compris tout ou partie des entretiens vidéo le
							concernant,
							peuvent être communiquées aux Entreprises intéressées par son profil.</span>
						<span>Conformément au règlement n°2016/679, dit règlement général sur la protection des données (“RGPD”), et à la loi dite «
							informatique et libertés » du 6 janvier 1978, l’Utilisateur personne physique dispose d’un droit d’opposition, d’accès, de
							rectification
							et de suppression sur les données personnelles le concernant, qu’il peut exercer en adressant une copie d’une pièce d’identité
							comportant sa signature à son nom, en envoyant un message à administration@bruce.work. En particulier, les Candidats et Intérimaires
							sont informés de la possibilité qui leur est offerte par Bruce, en envoyant un message à administration@bruce.work, de connaître et,
							le
							cas échéant, de contester les évaluations, notamment de performance, qui sont faites d’eux par Bruce lors de l’inscription au
							Service,
							et/ou par les Entreprises à l’issue de l’exécution de chaque Contrat de Mission.</span>
						<span>L’Entreprise s’engage à porter à la connaissance des Intérimaires les informations concernant l’utilisation qu’elle fait des
							données personnelles qu’elles collectent concernant les Intérimaires dans le cadre de chaque Mission, et ce, dans le respect des
							dispositions de la loi « informatique et libertés » susmentionnée.</span>
						<span>Bruce ne fait usage que de cookies purement techniques pour recueillir des données statistiques sur notre audience afin
							d’améliorer la qualité de nos services et l’ergonomie de notre Site et pour faciliter l’utilisation de ses sites.</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						7. RESPONSABILITE ET FORCE MAJEURE

					</Title>
					<p>
						<span>En cas de force majeure ou de faits indépendants de sa volonté, notamment dans les cas d’interruption des réseaux d’accès ou des
							réseaux accessibles par les services ou de la défaillance du matériel de réception ou de la ligne de l’utilisateur, la
							responsabilité de
							Bruce ne saurait être engagée pour les pertes de données, altération, modification, interruptions, lenteurs et inaccessibilités du
							réseau Internet ou de tout autre problème affectant les transmissions sur les réseaux de télécommunications et perturbant
							l’utilisation
							du site ou de l’internet ne lui étant pas directement et exclusivement imputables.</span>
						<span>Bruce ne garantit en aucun casu’une Entreprise Sollicitera l’information mise à disposition par les Candidats, proposera un
							entretien, ni n’embauchera un Candidat, ni que le Candidat sera disponible ou correspondra aux besoins d’une Entreprise.</span>
						<span>En utilisant les présents Services, les Utilisateurs reconnaissent assumer les risques relatifs à la non complétude, exactitude,
							adéquation ou actualité de l’information.</span>
						<span>Par ailleurs, Bruce supprimera les comptes et bloquera l’accès à ses Services à tout Utilisateur qui serait en violation des
							présentes Conditions Générales d’Utilisation. Nous nous réservons le droit d’entreprendre ces actions à tout moment, à notre seule
							discrétion, avec ou sans préavis, et sans responsabilité de notre part à l’égard du titulaire de compte désabonné ou à l’égard de
							l’Utilisateur dont l’accès est bloqué.</span>
						<span>Les Utilisateurs reconnaissent être informés  que Bruce fournira tout renseignement permettant ou facilitant l’identification de
							celui s’étant rendu coupable d’une infraction à la législation ou d’une atteinte aux droits de Bruce ou d’un tiers, sur requête
							émanant
							d’une autorité légitime, tels qu’adresse IP et heures de connexion si ceux-ci sont encore en sa possession. Dans le cas où la
							responsabilité de Bruce serait judiciairement recherchée en raison d’un manquement par un Utilisateur aux obligations qui lui
							incombent,
							Bruce pourra appeler ce dernier en garantie.</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						8. NULLITÉ PARTIELLE

					</Title>
					<p>
						<span>Dans l’hypothèse où l’une des clauses des présentes Conditions Générales d’Utilisation serait déclarée nulle aux termes d’une
							décision judiciaire ou administrative, d’une disposition légale ou réglementaire, cela ne saurait en aucun cas affecter la validité
							de
							l’ensemble des présentes CGU  ni le respect des autres clauses des présentes.</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						9. DURÉE

					</Title>
					<p>
						<span>Les présentes CGU sont conclues pour une durée indéterminée à compter de l’inscription de l’Utilisateur. Il peut être mis un terme
							à tout moment à l’utilisation des Services, en adressant une demande par email à l’adresse administration@bruce.work ou par Chat. La
							désinscription est effective immédiatement et entraîne la suppression automatique du Compte de l’Utilisateur.</span>
						<span>Les Utilisateurs avec des Missions en cours à la date de demande de désinscription resteront engagés par  tous les contrats signés
							avec Bruce, en ce compris les présentes Conditions générales d’utilisation, jusqu’au temps nécessaire à leur application.</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						10. MODIFICATIONS

					</Title>

					<p>
						<span>Bruce se réserve le droit de modifier les présentes CGU à tout moment en notifiant par tout moyen les modifications aux
							Utilisateurs, qui s’engagent à prendre connaissance. L’Utilisateur qui n’accepte pas les conditions générales modifiées doit
							immédiatement cesser d’utiliser la Plateforme et se désinscrire des Services selon les modalités définies ci-après.</span>
						<span>Dans le cas où l’Utilisateur ne se serait pas désinscrit et recours aux Services postérieurement à l’entrée en vigueur des
							nouvelles CGU, il sera réputé avoir accepté ces modifications.</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						11. LANGUE

					</Title>

					<p>
						<span>Dans l’hypothèse d’une traduction des présentes conditions générales dans une ou plusieurs langues, la langue d’interprétation
							sera la langue française en cas de contradiction ou de contestation sur la signification d’un terme ou d’une disposition.</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						12. DROIT APPLICABLE ET JURIDICTION COMPETENTE

					</Title>
					<p>
						<span>Les présentes Conditions Générales d’Utilisation sont régies par la loi française. En cas de contestation sur l’interprétation,
							sur l’exécution et la réalisation de l’une quelconque des stipulations des présentes Conditions Générales d’Utilisation et à défaut
							d’accord amiable entre les parties, les Tribunaux de Nanterre seront seuls compétents pour connaître du litige.</span>
					</p>

					<Title underlineColor="red" padding=".8em 0 0em" fontSize="1.4em">

						13. ENTRÉE EN VIGUEUR

					</Title>
					<p>
						<span>Les présentes conditions générales, dans leur version modifiée, entrent en vigueur le 1er juin 2020.</span>
					</p>

				</SectionText>
			</CustomSection>
		</PageWrapper>
	);
	// #endregion
};
// #endregion

// #region CONNEXION
export const getServerSideProps = async ({ query }) => {
	return {
		props: {
			...await serverSideTranslations(query.language, ['navbar', 'footer'], nextI18NextConfig),
		},
	};
};
// #endregion

export default (Cgu);
